import { render } from "./EventsHome.vue?vue&type=template&id=21cec82b&scoped=true"
import script from "./EventsHome.vue?vue&type=script&lang=js"
export * from "./EventsHome.vue?vue&type=script&lang=js"

import "./EventsHome.vue?vue&type=style&index=0&id=21cec82b&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cec82b"]])

export default __exports__